<div class="navigation flex items-center container">
  <vex-navigation-item *ngFor="let item of items" [item]="item"></vex-navigation-item>
</div>

